const annualMultiplierByFrequency = {
  annually: 1,
  quarterly: 4,
  monthly: 12,
  fortnightly: 26,
  weekly: 52,
};

export const annualNetIncomeThresholdByCountry = {
  AU: 19750,
  NZ: 17500,
};

function annualAmount(income = {}) {
  const amount = Number(income.amount);
  const multiplier = annualMultiplierByFrequency[income.frequency];

  return Number.isFinite(amount) && multiplier ? amount * multiplier : 0;
}

export function getAnnualIncome(employmentDetails = {}) {
  const primaryIncome = annualAmount(employmentDetails.income);
  const additionalIncome = employmentDetails.hasOtherIncome === 'yes' ? annualAmount(employmentDetails.otherIncome) : 0;

  return primaryIncome + additionalIncome;
}

export function getIncomeThresholdError(employmentDetails, country) {
  const threshold = annualNetIncomeThresholdByCountry[country];

  if (!threshold || getAnnualIncome(employmentDetails) >= threshold) {
    return null;
  }

  return `Annual take-home pay must exceed $${threshold.toLocaleString('en-AU')}.`;
}
